import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Mindset from "./components/Mindset";
import Coaching from "./components/Coaching";
import Coaches from "./components/Coaches";
import People from "./components/People";
import Experience from "./components/Experience";
import Newsletter from "./components/Newsletter";
import Events from "./components/Events";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="site-shell" id="top">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Mindset />
        <Coaching />
        <Coaches />
        <People />
        <Experience />
        <Newsletter />
        <Events />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
